import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';

export default function AutoCompleteSimples(props) {
    const {
        options = [],
        label = '',
        getLabel = (item) => item?.label || '',
        value: propValue,
        onChange
    } = props;

    const [value, setValue] = useState(null);

    useEffect(() => {
        if (propValue) {
            const selected = options.find(opt => opt.id === propValue.id);
            setValue(selected || null);
        } else {
            setValue(null);
        }
    }, [propValue, options]);

    return (
        <div style={{ width: props.width || '30%', minWidth: props.width || '20%', paddingRight: '10px', paddingBottom: '2px' }}>
            <Autocomplete className="autocomplete"
                {...{label: props.label, width: props.width}}
                style={{ all: 'unset' }}
                className="autocomplete"
                options={options}
                value={value}
                getOptionLabel={getLabel}
                onChange={(event, newValue) => {
                    setValue(newValue);
                    if (onChange) onChange(newValue);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        variant="standard"
                    />
                )}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
            />
        </div>
    );
}
